<template>
	<div class="insideBody">
		<div class="infimgList">
			<img src="../../assets/images/tdt.jpg" />
<!-- 			<img src="../../assets/images/tdt2.jpg" />
			<img src="../../assets/images/tdt3.jpg" />
			<img src="../../assets/images/tdt4.jpg" /> -->
		</div>
	</div>
</template>
<script>
export default {
  data(){
    return {
			height: null
		};
	},
	created(){
	},
	methods:{
	},
	mounted(){
	},
	components: {
		
	},
}
</script>
<style scoped>
	
</style>